import React from "react";
import { useTranslation } from 'react-i18next';
import SangriaForm from "../../Forms/SangriaForm";

import "./modern-styles.css";

const SangriaModal = ({ onClose }) => {
  const { t } = useTranslation('cashRegister');

  return (
    <div className="sangria-modal-container">
      <div className="sangria-header-unique">
        <h1 className="sangria-title-unique">
          {t('sangria.modalTitle')}
        </h1>
        <p className="sangria-subtitle-unique">
          {t('sangria.modalSubtitle')}
        </p>
      </div>
      <div className="sangria-form-container-unique">
        <SangriaForm onClose={onClose} />
      </div>
    </div>
  );
};

export default SangriaModal;
